import { SpecialtyViewModel, SpecialtyCreateCommand, SpecialtyUpdateCommand } from '../../models/Entities/Specialties/SpecialtyModels';
import { ErrorType } from '../../models/HttpError';

export const SPECIALTIES_GETALL_REQUEST = 'SPECIALTIES_GETALL_REQUEST';
export const SPECIALTIES_GETALL_SUCCESS = 'SPECIALTIES_GETALL_SUCCESS';
export const SPECIALTIES_GETALL_FAILURE = 'SPECIALTIES_GETALL_FAILURE';

export interface SpecialtiesGetAllRequestAction {
    type: typeof SPECIALTIES_GETALL_REQUEST;
}

export interface SpecialtiesGetAllSuccessAction {
    type: typeof SPECIALTIES_GETALL_SUCCESS;
    payload: SpecialtyViewModel[];
}

export interface SpecialtiesGetAllFailureAction {
    type: typeof SPECIALTIES_GETALL_FAILURE;
    error: ErrorType;
}

export const SPECIALTIES_GETBYID_REQUEST = 'SPECIALTIES_GETBYID_REQUEST';
export const SPECIALTIES_GETBYID_SUCCESS = 'SPECIALTIES_GETBYID_SUCCESS';
export const SPECIALTIES_GETBYID_FAILURE = 'SPECIALTIES_GETBYID_FAILURE';

export interface SpecialtiesGetByIdRequestAction {
    type: typeof SPECIALTIES_GETBYID_REQUEST;
    id: number;
}

export interface SpecialtiesGetByIdSuccessAction {
    type: typeof SPECIALTIES_GETBYID_SUCCESS;
    payload: SpecialtyViewModel;
}

export interface SpecialtiesGetByIdFailureAction {
    type: typeof SPECIALTIES_GETBYID_FAILURE;
    error: ErrorType;
}

export const SPECIALTIES_CREATE_REQUEST = 'SPECIALTIES_CREATE_REQUEST';
export const SPECIALTIES_CREATE_SUCCESS = 'SPECIALTIES_CREATE_SUCCESS';
export const SPECIALTIES_CREATE_FAILURE = 'SPECIALTIES_CREATE_FAILURE';

export interface SpecialtiesCreateRequestAction {
    type: typeof SPECIALTIES_CREATE_REQUEST;
    payload: SpecialtyCreateCommand;
}

export interface SpecialtiesCreateSuccessAction {
    type: typeof SPECIALTIES_CREATE_SUCCESS;
    payload: SpecialtyViewModel;
}

export interface SpecialtiesCreateFailureAction {
    type: typeof SPECIALTIES_CREATE_FAILURE;
    error: ErrorType;
}

export const SPECIALTIES_UPDATE_REQUEST = 'SPECIALTIES_UPDATE_REQUEST';
export const SPECIALTIES_UPDATE_SUCCESS = 'SPECIALTIES_UPDATE_SUCCESS';
export const SPECIALTIES_UPDATE_FAILURE = 'SPECIALTIES_UPDATE_FAILURE';

export interface SpecialtiesUpdateRequestAction {
    type: typeof SPECIALTIES_UPDATE_REQUEST;
    payload: SpecialtyUpdateCommand;
}

export interface SpecialtiesUpdateSuccessAction {
    type: typeof SPECIALTIES_UPDATE_SUCCESS;
    payload: SpecialtyViewModel;
}

export interface SpecialtiesUpdateFailureAction {
    type: typeof SPECIALTIES_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const SPECIALTIES_DELETE_REQUEST = 'SPECIALTIES_DELETE_REQUEST';
export const SPECIALTIES_DELETE_SUCCESS = 'SPECIALTIES_DELETE_SUCCESS';
export const SPECIALTIES_DELETE_FAILURE = 'SPECIALTIES_DELETE_FAILURE';

export interface SpecialtiesDeleteRequestAction {
    type: typeof SPECIALTIES_DELETE_REQUEST;
    id: number;
}

export interface SpecialtiesDeleteSuccessAction {
    type: typeof SPECIALTIES_DELETE_SUCCESS;
    id: number;
}

export interface SpecialtiesDeleteFailureAction {
    type: typeof SPECIALTIES_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}
